export default "__VITE_ASSET__d48ec411__"